import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _previousUrl: string | null = null;
  private _currentUrl: string | null = null;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this._previousUrl = this._currentUrl;
        this._currentUrl = event.urlAfterRedirects;
      }
    });
  }

  public get previousUrl(): string | null {
    return this._previousUrl;
  }

  public get currentUrl(): string | null {
    return this._currentUrl;
  }
}
